import Header from "components/header";
import MenuLateral from "components/menu-lateral";
import Paper from "material-ui/Paper";
import MenuIcon from "material-ui/svg-icons/navigation/menu";
import BudgetFamily from "pages/master-data/budget-family";
import CriticalItem from "pages/master-data/configurations/critical-items";
import DataUpload from "pages/master-data/configurations/data-upload";
import GeneralSettings from "pages/master-data/configurations/general-settings";
import IMOManagement from "pages/master-data/configurations/imo-management";
import ConfiguracoesIntegracoes from "pages/master-data/configurations/integrations";
import MasterdataAutomationNotifications from "pages/master-data/configurations/masterdata-automation-notifications";
import PermissionsSettings from "pages/master-data/configurations/permissions-settings";
import ReleaseVersion from "pages/master-data/configurations/release-version";
import UnidadesArredondamento from "pages/master-data/configurations/rounding-unit";
import CoordinationUser from "pages/master-data/coordination-user";
import General from "pages/master-data/general-configuration/general";
import MaterialBusinessUnit from "pages/master-data/general-configuration/material-business-unit";
import Material from "pages/master-data/material";
import MasterSupplier from "pages/master-data/suppliers";
import BusinessUnit from "pages/master-data/unit-management/business-unit";
import DeliveryScheduleConfiguration from "pages/master-data/unit-management/delivery-schedule-configuration";
import Grade from "pages/master-data/unit-management/grade";
import SiloManagement from "pages/master-data/unit-management/silos";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import "./master-data.css";
import { AutoPilot } from "pages/auto-pilot";
import GridParameterization from "pages/master-data/unit-management/grid-parameterization";
import ForbiddenAccess from "pages/forbidden-access/index";
import { isFeatureEnabled } from "utils/feature-flags";
import { profileAdmin } from "services/permissions/getPermissions";
import { getMenuList } from "./utils";

const MasterData = ({ history, match }) => {
  const transitionTime = 600;
  const { url } = match;
  const [exibirMenu, setExibirMenu] = useState(false);
  const [hidden, setHidden] = useState(true);
  const [listaMenus, setListaMenus] = useState(getMenuList());

  useEffect(() => {
    const loadFeatureFlags = async () => {
      const isEnabled = await isFeatureEnabled("FeatureLoadAndUnloadCapacity");
      if(isEnabled) {
        setListaMenus(getMenuList(isEnabled));
      }
    };

    loadFeatureFlags();
  }, []);

  const exibirMenuClick = () => {
    if (exibirMenu) {
      handleClickOver();
    } else {
      setExibirMenu(true);
      setHidden(false);
    }
  };

  const handleClickOver = () => {
    return new Promise((resolve) => {
      setExibirMenu(false);

      setTimeout(() => {
        setHidden(true);
        resolve();
      }, transitionTime);
    });
  };

  const onChangeUrl = (rota) => {
    history.push(`${url}/${rota}`);
  };

  return (
    <div className="container-master-detail">
      <div>
        <Header
          title="Master Data"
          icon={<MenuIcon color="#b3b3b3" />}
          onClickIcon={exibirMenuClick}
        />

        <MenuLateral
          exibirMenu={exibirMenu}
          hidden={hidden}
          onHandleClickOver={handleClickOver}
          transitionTime={transitionTime}
          onChangeUrl={onChangeUrl}
          listaMenus={listaMenus}
        />

        <Paper zDepth={0} className="master-body-container">
          <Switch>
            <Route path={`${url}/general`} component={General} />
            <Route path={`${url}/budget-family`} component={BudgetFamily} />
            <Route path={`${url}/coordination-user`} component={CoordinationUser} />
            <Route path={`${url}/supplier`} component={MasterSupplier} />
            <Route path={`${url}/material`} component={Material} />
            <Route path={`${url}/business-unit`} component={BusinessUnit} />
            <Route
              path={`${url}/general-material/:labeledFamilyCenterId?`}
              component={MaterialBusinessUnit}
            />
            <Route path={`${url}/general-auto-pilot/:id`} component={AutoPilot} />
            <Route path={`${url}/parametrizacao-grade`} component={Grade} />
            <Route path={`${url}/grid-parameterization`} component={GridParameterization} />
            <Route path={`${url}/silo-management`} component={SiloManagement} />
            <Route path={`${url}/configuracoes-integracoes`} component={ConfiguracoesIntegracoes} />
            <Route path={`${url}/unidades-arredondamento`} component={UnidadesArredondamento} />
            <Route path={`${url}/release-version`} component={ReleaseVersion} />
            <Route path={`${url}/critical-items`} component={CriticalItem} />
            <Route path={`${url}/data-upload`} component={DataUpload} />
            <Route path={`${url}/permissions-settings`} component={PermissionsSettings} />
            <Route path={`${url}/imo-management`} component={IMOManagement} />
            <Route
              path={`${url}/delivery-schedule-configuration`}
              component={DeliveryScheduleConfiguration}
            />
            <Route
              path={`${url}/configurations/general-settings`}
              component={profileAdmin() ? GeneralSettings : ForbiddenAccess}
            />
            <Route
              path={`${url}/general-settings`}
              component={profileAdmin() ? GeneralSettings : ForbiddenAccess}
            />
            <Route
              path={`${url}/automation-notifications`}
              component={MasterdataAutomationNotifications}
            />
          </Switch>
        </Paper>
      </div>
    </div>
  );
};

MasterData.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.any,
  }).isRequired,
};

export default MasterData;
